import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Network, NetworkServer, NetworkService} from "../../../../../../../services/back/network.service";
import {DataCollectionStatus, Server} from "../../../../../../../services/model/server.model";
import {ServerService} from "../../../../../../../services/back/server.service";
import {CurrentTenantService} from "../../../../../../../services/front/current-tenant.service";
import {SnackbarService} from "../../../../../../../services/front/snackbar.service";
import {MatDialog} from "@angular/material/dialog";
import {of, Subscription, tap} from "rxjs";
import {NetworkDetailService} from "../../../../../../../services/front/network-detail.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DesignSystemModule} from "../../../../../../design-system/design-system.module";
import {CommonModule} from "@angular/common";
import {MiniButtonModule} from "../../../../../../global/button/mini-button/mini-button.module";
import {INFRASTRUCTURE_SERVERS_URL} from "../../../../../../../models/home/navigation.model";
import {Router} from "@angular/router";
import {DateUtils} from "../../../../../../../utils/date.utils";
import {IpCheckerService} from "../../../../../../../services/front/ip-checker.service";

@Component({
	selector: 'app-network-servers',
	standalone: true,
	imports: [
		DesignSystemModule,
		MiniButtonModule,
		CommonModule,
		TranslateModule
	],
	templateUrl: './network-servers.component.html',
	styleUrl: './network-servers.component.scss'
})
export class NetworkServersComponent implements OnInit, OnDestroy {
	@Input() network: Network;
	@Input() servers: NetworkServer[];
	@Input() tooMuchServers: boolean = false;

	tenantId: string

	subscription: Subscription = new Subscription();

	constructor(private router: Router,
				private serverService: ServerService,
				private networkService: NetworkService,
				private currentTenantService: CurrentTenantService,
				private snackbarService: SnackbarService,
				private dialog: MatDialog,
				private ipCheckerService: IpCheckerService,
				private networkDetailService: NetworkDetailService,
				private translate: TranslateService) {
	}

	ngOnInit() {
		this.subscription.add(this.currentTenantService.getCurrentTenantIdChanges()
			.pipe(tap(tenantId => this.tenantId = tenantId))
			.subscribe());
	}

	goToServer(serverId: string) {
		this.currentTenantService.getCurrentTenantId().subscribe(tenantId => {
			this.router.navigate([INFRASTRUCTURE_SERVERS_URL], {
				queryParams: {
					tenant: tenantId,
					serverId: serverId
				}
			});
		});
	}

	getDataCollectionStatusTooltip(dataCollectionStatus: DataCollectionStatus, date: string | null): string {
		const index: number = Object.keys(DataCollectionStatus).indexOf(dataCollectionStatus.toString());

		if (date && index < 2) {
			switch (index) {
				case 0 :
					return 'Last collect ' + DateUtils.secondsOrDhms((DateUtils.toSecondUTC(new Date()) - new Date(date).getTime()) / 1000) + ' ago.';
				default:
					return 'Last collect outdated (>15 min)<br>(' + DateUtils.secondsOrDhms((DateUtils.toSecondUTC(new Date()) - new Date(date).getTime()) / 1000) + ' ago)';
			}
		} else {
			switch (index) {
				case 2 :
					return 'No data yet.'
				case 3 :
					return 'Error while retrieving data.<br>Kapsul was unable to collect data.'
				default:
					return 'No data yet.'
			}
		}
	}

	isIpInRange(serverIp: string, networkIp: string, subnet: string): boolean {
		return this.ipCheckerService.isIpInRange(serverIp, networkIp, subnet);
	}

	getServerPrimaryIpAddress(server: Server): string | undefined {
		return server.interfaces.find(i => i.serverInterface.isPrimary)?.serverInterface.ipAddress;
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}

	protected readonly DataCollectionStatus = DataCollectionStatus;
}

export interface AddServersToNetworkDialogData {
	server: Server;
	selected: boolean;
}
